import { styled } from 'styled-components';
import { Button } from '@/shared/ui/form/button/button';
import { Box } from '@/shared/ui/box/Box';

export const WalletButton = styled(Button)<{ $isLoading?: boolean }>`
  width: 100%;
  position: relative;

  ${({ $isLoading }) =>
    $isLoading &&
    `
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        background-image: url('/images/icons/element-loader.svg');
        background-size: contain;
        background-repeat: no-repeat;
      }
    
  `}
`;

export const WrapperButton = styled(Box)`
  position: absolute;
  bottom: calc(18px + var(--app-safe-area-bottom));
  left: 18px;
  width: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 1000;
`;
